import { elements } from './elements.js';
import {
    bindSearchInput,
    bindFormFields,
    bindFormSubmission,
    bindClearAllButton,
    resetAndFetchResults
} from '../shared/singleSectionSearch.js';

export const bindFormElements = (fetchResults, updateQueryString, allChoices) => {
    const {
        searchForm,
        searchInput,
        yearSelect,
        fundingTypeSelect,
        clearSearchButton,
        searchButton,
        clearAllButton
    } = elements;

    if (
        !searchForm ||
        !searchInput ||
        !yearSelect ||
        !fundingTypeSelect ||
        !clearAllButton
    ) return;

    bindSearchInput(
        searchInput,
        () => resetAndFetchResults(fetchResults, updateQueryString, searchForm),
        clearSearchButton,
        searchButton
    );

    bindFormFields(
        [yearSelect, fundingTypeSelect],
        () => resetAndFetchResults(fetchResults, updateQueryString, searchForm)
    );

    bindFormSubmission(
        searchForm,
        () => resetAndFetchResults(fetchResults, updateQueryString, searchForm)
    );

    bindClearAllButton(clearAllButton, searchForm, () => {
        Object.values(allChoices).forEach(choice => choice.setChoiceByValue(''));
        resetAndFetchResults(fetchResults, updateQueryString, searchForm);
    });
};
